import React from 'react'

const DownloadBtn = ({videoUrl}) => {
  return (
    <a href={videoUrl} download className='download_btn_container'>
        <span>Download</span>
        <i className="fa fa-download" aria-hidden="true"></i>
    </a>
  )
}

export default DownloadBtn


// WEBPACK FOOTER //
// ./src/components/DownloadBtn/DownloadBtn.js